import styled from 'styled-components'
import breakPoints from 'themes/breakPoints'

export default styled.div`
  margin-left: auto;
  margin-right: auto;
  @media (max-width: ${breakPoints.xs.max}px) {
    margin-left: 16px;
    margin-right: 16px;
  }
  @media (min-width: ${breakPoints.sm.min}px) {
    width: 540px;
  }
  @media (min-width: ${breakPoints.md.min}px) {
    width: 720px;
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    width: 960px;
  }
  @media (min-width: ${breakPoints.xl.min}px) {
    width: 1140px;
  }
`
